import type { TableSortValue } from "@src/shared/constants/sort-order.constants";
import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";

export type FeatureControlStatus = "active" | "inactive" | "maintenance";

export interface FeatureAssignedUser {
  userId: number;
  email: string;
  userName?: string | null;
  role?: string | null;
}

export interface FeatureControlAssignment {
  id: number;
  featureId: number;
  actorType: string;
  userId: number;
  userName?: string | null;
  userEmail?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface FeatureControl {
  id: number;
  key: string;
  name?: string | null;
  status: FeatureControlStatus;
  description?: string | null;
  createdBy?: number | null;
  updatedBy?: number | null;
  createdAt: string;
  updatedAt?: string | null;
  assignedUsers?: FeatureAssignedUser[];
  assignments?: FeatureControlAssignment[];
  userIds?: number[];
  roles?: string[];
  assignedRoles?: string[];
  assignAllUsers?: boolean;
  assignAllRoles?: boolean;
  assignmentCount?: number;
  userCount?: number;
  roleCount?: number;
}

export interface AddFeatureControl {
  key: string;
  name?: string;
  description?: string;
  status?: FeatureControlStatus;
  userIds?: number[];
  roles?: string[];
  assignAllUsers?: boolean;
  assignAllRoles?: boolean;
}

export interface GetFeatureControlsParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: TableSortValue;
  [key: string]: unknown;
}

export class FeatureControlService {
  async getFeatureControls(query?: GetFeatureControlsParams) {
    return apiService.get("/feature-controls", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getFeatureControlDetails(id: string | number) {
    return apiService.get(`/feature-controls/${id}`);
  }

  async addFeatureControl(data: AddFeatureControl) {
    return apiService.post("/feature-controls", data);
  }

  async updateFeatureControl(
    id: string | number,
    data: Partial<AddFeatureControl>
  ) {
    return apiService.put(`/feature-controls/${id}`, data);
  }

  async deleteFeatureControl(id: string | number) {
    return apiService.delete(`/feature-controls/${id}`);
  }
}

export const featureControlService = new FeatureControlService();
